import React from "react";
import { Swiper as SwiperComponent, SwiperSlide } from "swiper/react";

import { Autoplay } from "swiper/modules";

import "swiper/css";

const BrandPartnersSwiper = () => {
  return (
    <section
    style={{
        width: "100%",
        padding: "75px 0",
        background: "#fff",
        overflow: "hidden",
    }}
>
    <div
        className="container"
        style={{
            maxWidth: "1280px",
            margin: "0 auto",
            padding: "0 15px",
        }}
    >
        <div
            style={{
                textAlign: "center",
                marginBottom: "45px",
            }}
        >
            <div
                style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "12px",
                    marginBottom: "12px",
                }}
            >
                <span
                    style={{
                        width: "30px",
                        height: "1px",
                        background: "#b08b57",
                    }}
                />

                <span
                    style={{
                        color: "#a17c4b",
                        fontFamily: "Arial, sans-serif",
                        fontSize: "10px",
                        fontWeight: "700",
                        letterSpacing: "3px",
                        textTransform: "uppercase",
                    }}
                >
                    TRUSTED BY
                </span>

                <span
                    style={{
                        width: "30px",
                        height: "1px",
                        background: "#b08b57",
                    }}
                />
            </div>

            <h2
                style={{
                    margin: "0 0 12px",
                    color: "#191919",
                    fontFamily: "Georgia, serif",
                    fontSize: "clamp(30px, 4vw, 44px)",
                    fontWeight: "400",
                    lineHeight: "1.2",
                }}
            >
                Our Partners
            </h2>

            <p
                style={{
                    maxWidth: "600px",
                    margin: "0 auto",
                    color: "#777",
                    fontFamily: "Arial, Helvetica, sans-serif",
                    fontSize: "14px",
                    lineHeight: "1.7",
                }}
            >
                Building lasting relationships with trusted brands and
                organizations to deliver exceptional interior solutions.
            </p>
        </div>

        <SwiperComponent
            modules={[Autoplay]}
            spaceBetween={20}
            slidesPerView={1}
            loop={true}
            autoplay={{
                delay: 0,
                disableOnInteraction: false,
                pauseOnMouseEnter: true,
            }}
            speed={3500}
            breakpoints={{
                320: {
                    slidesPerView: 1,
                    spaceBetween: 15,
                },
                576: {
                    slidesPerView: 2,
                    spaceBetween: 18,
                },
                992: {
                    slidesPerView: 3,
                    spaceBetween: 20,
                },
            }}
        >

            <SwiperSlide>
                <div
                    style={{
                        height: "140px",
                        background: "#ffffff",
                        border: "1px solid #e5e3df",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        padding: "20px",
                        boxSizing: "border-box",
                        transition: "all 0.3s ease",
                    }}
                >
                    <img
                        src="/assets/images/apollo.jpeg"
                        alt="Apollo"
                        style={{
                            width: "100%",
                            maxWidth: "200px",
                            height: "90px",
                            objectFit: "contain",
                            display: "block",
                        }}
                    />
                </div>
            </SwiperSlide>

            

            <SwiperSlide>
                <div
                    style={{
                        height: "140px",
                        background: "#ffffff",
                        border: "1px solid #e5e3df",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        padding: "20px",
                        boxSizing: "border-box",
                        transition: "all 0.3s ease",
                    }}
                >
                    <img
                        src="/assets/images/birla.jpeg"
                        alt="Birla"
                        style={{
                            width: "100%",
                            maxWidth: "200px",
                            height: "90px",
                            objectFit: "contain",
                            display: "block",
                        }}
                    />
                    
                </div>
                
            </SwiperSlide>

            <SwiperSlide>
                <div
                    style={{
                        height: "140px",
                        background: "#ffffff",
                        border: "1px solid #e5e3df",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        padding: "20px",
                        boxSizing: "border-box",
                        transition: "all 0.3s ease",
                    }}
                >
                    <img
                        src="/assets/images/davaindia.jpeg"
                        alt="Dava India"
                        style={{
                            width: "100%",
                            maxWidth: "200px",
                            height: "90px",
                            objectFit: "contain",
                            display: "block",
                        }}
                    />
                </div>
            </SwiperSlide>

        </SwiperComponent>

        <div
            style={{
                textAlign: "center",
                marginTop: "35px",
                color: "#999",
                fontFamily: "Arial, sans-serif",
                fontSize: "10px",
                letterSpacing: "2px",
            }}
        >
            TRUSTED PARTNERS • PROFESSIONAL EXCELLENCE
        </div>
    </div>
</section>

  );
};

const imgStyle = {
  width: "100%",
  height: "120px",
  objectFit: "contain",
};

export default BrandPartnersSwiper;
